<template>
<div>
	<ul class="title-nav">
		<li>
			<div v-on:click="routeBack()" class="back-btn">
				<i class="material-icons md-18">keyboard_arrow_left</i>
			</div> 
			
			<div class="title-label"><i class="material-icons md-18">verified_user</i> PLAN</div>
		</li>
	</ul>

	<div class="category-body">
		<div class="category">
			<div class="category-title">PLAN DETAILS</div>
			<div class="property-row">
				<label>Type</label>
				<div class="property-value-right">
					{{planName}}
				</div>
			</div>
			<div class="property-row">
				<label>Status</label>
				<div class="property-value-right">
					{{status}}
				</div>
			</div>
			<div class="property-row">
				<label>Purchased</label>
				<div class="property-value-right">
					{{planCurrent.created | longDate}} @{{planCurrent.created | time}}
				</div>
			</div>
			<div v-if="isDayPass">
				<div v-if="status === 'active'" class="property-row">
					<label>Expires</label>
					<div class="property-value-right">
						{{planExpires | longDate}} @{{planCurrent.created | time}}
					</div>
				</div>
				<div v-if="status === 'expired'" class="property-row">
					<label>Expired</label>
					<div class="property-value-right">
						{{planExpires | longDate}} @{{planCurrent.created | time}}
					</div>
				</div>
				<div class="property-row" v-if="status === 'expired'">
					<button v-on:click="routeUnlock" class="btn btn-green btn-sm float-right">RENEW DAY PASS</button>
				</div>
			</div>
		</div>
	</div>
</div>

</template>

<script>

const dayTs = 24*60*60*1000; 

export default {
	data: function(){
		return {
			error:null,
			mode:'view',
			newEmail:'',
		}
	},
	computed:{
		status:function(){
			if (this.planCurrent.plan.id === 'plan_1') return 'active';
			if (this.planCurrent.plan.id === 'plan_3') return 'active';
			let currentPlanTs = new Date(this.planCurrent.created).getTime();
			let left = (currentPlanTs + dayTs)-this.$data.nowTs;
			if (left > 0) return 'active';
			else return 'expired';
		},
		planExpires:function(){
			let currentPlanTs = new Date(this.planCurrent.created).getTime();
			let expires = new Date(currentPlanTs + dayTs).toUTCString();
			return expires;
		},
		planName:function(){
			if (this.planCurrent.plan.id === 'plan_3') return 'Annual Subscription';
			if (this.planCurrent.plan.id === 'plan_2') return 'Day Pass';
			if (this.planCurrent.plan.id === 'plan_1') return 'Studio Subscription';
		},
		isDayPass:function(){
			if (this.planCurrent.plan.id === 'plan_2') return true;
			return false;
		}

	},
	props: {
		agent:{
			type:Object
		},
		planCurrent:{
			type:Object
		},
	},
	methods:{
		routeBack:function(){
			this.$router.push({
				name:'agent',
			});
		},
		editCancel:function(){
			this.mode = 'view';
		},
		editShow:function(){
			this.mode = 'edit';
		},
		routeClose:function(){
			this.$router.push({
				name:'home'
			});
		},
		routeUnlock:function(){
			this.$router.push({
				name:'unlock'
			});
		}
	},
	mounted:function(){
		this.$data.nowTs = new Date().getTime();
		this.interval = setInterval(()=>{
			this.$data.nowTs = new Date().getTime();
		},60000);
	},
	data:function(){
		return {
			nowTs:0
		};
	},
	destroyed:function(){
		if (this.interval) clearInterval(this.interval);
	},
}

</script>


// WEBPACK FOOTER //
// src/components/agent/agent-plan.vue